import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { Box, Toolbar } from "@mui/material";
import { Navigation } from "../component/Navigation";
import { Outlet } from "react-router-dom";
import { getTranslations, setParams } from "../actions";
import { saveToSessionStorage } from "../utils/sessionStorage";
import { LocalizationService } from "../locales/i18n";

function Main() {
  const { i18n } = useTranslation();
  const dispath = useDispatch();
  const location = useLocation();
  const { user_type, version, lang } = useParams();
  const translation = useSelector((state) => state.uiReducer.translations);

  useEffect(() => {
    for (const lang of translation) {
      i18n.addResourceBundle(lang.code, "translation", lang.translations);
    }
  }, [translation, i18n]);

  useEffect(() => {
    dispath(getTranslations());
    dispath(setParams({ user_type, version, language: lang }));
  }, [location, user_type, version, lang, dispath]);

  useEffect(() => {
    dispath(getTranslations());
  }, [dispath]);

  useEffect(() => {
    LocalizationService.changeLanguage(lang);
  }, [lang]);

  return (
    <Box>
      <Navigation />
      <Toolbar />
      <Box flexGrow={1} sx={{ p: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
}

Main.defaultProps = {
  children: PropTypes.any,
};

Main.propTypes = {
  children: PropTypes.any,
};

export default React.memo(Main);
